<template>
  <div class="maincont" id="detail_monitoring">
    <div id="charts">
      <div class="ef--inner">
        <div id="monitoring">
          <h2>電気使用・天気実績</h2>
          <a v-if="this.$store.state.loginType != 3"
            href="javascript:void(0);"
            class="dlbtn4"
            @click="showModalMeter = true"
          >データ入力</a>
          <a
            href="javascript:void(0);"
            class="dlbtn3"
            @click="showModal = true;downloadType='demandfile'"
          >電力データ帳票ダウンロード</a>
          <a
            href="javascript:void(0);"
            class="dlbtn2"
            @click="showModal = true;downloadType='weatherfile'"
          >気象データ帳票ダウンロード</a>
          <a
            href="javascript:void(0);"
            class="dlbtn"
            @click="showModal = true;downloadType='temperaturefile'"
          >気温データ帳票ダウンロード</a>
          <p class="subttl">
             <span class="select-box">
              <select id="hyouji-graph" name="hyouji-graph" v-model="graphType">
                <option value="1" selected="selected">日間デマンド</option>
                <option value="2">月間電力使用実績</option>
                <option value="3">年間月別電力使用実績</option>
                <option value="4">検針データ</option>
              </select>
            </span>
              <a id="monthly-calendar-btn" href="javascript:void(0)" @click="$router.push('/monthly_calendar')">月間デマンド印刷</a>
          </p>
          <dl class="chart_display_date">
            <dt id="chart_monitoring_text">表示日</dt>
            <dd>
              <select v-model="selectedDate" id="monitoring_list">
                <option
                  v-for="(option, index) in dateOptions"
                  v-bind:value="option.value"
                  v-bind:key="index"
                >{{ option.text }}</option>
              </select>
            </dd>
          </dl>

          <!------------------------------------------------------------------
          <-- 日間
          <------------------------------------------------------------------>
          <div class="control_info" v-if="graphType == 1">
            <table>
              <thead>
                <tr>
                  <th style="width:160px;" rowspan="2">電気使用量</th>
                  <th style="width:160px;" v-show="showAirConditionerControl" rowspan="2">制御時限回数</th>
                  <th style="width:320px;" v-show="showAirConditionerControl" colspan="2">制御効果量</th>
                </tr>
                <tr>
                  <th style="width:160px;" v-show="showAirConditionerControl">最大抑制デマンド</th>
                  <th style="width:160px;" v-show="showAirConditionerControl">抑制電力量</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align:right; padding-right:25px;"><span>{{ electricPower }}</span>kWh</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlTimeCount }}</span>回</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ maxControlDemand }}</span>kW</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlPower }}</span>kWh</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!------------------------------------------------------------------
          <-- 月間
          <------------------------------------------------------------------>
          <div class="control_info" v-else-if="graphType == 2">
            <table>
              <thead>
                <tr>
                  <th style="width:160px;">電気使用量</th>
                  <th style="width:160px;" v-show="showAirConditionerControl">制御時限回数</th>
                  <th style="width:160px;" v-show="showAirConditionerControl">抑制電力量</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align:right; padding-right:25px;"><span>{{ electricPower }}</span>MWh</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlTimeCount }}</span>回</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlPower }}</span>MWh</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!------------------------------------------------------------------
          <-- 年間
          <------------------------------------------------------------------>
          <div class="control_info" v-show="showYearControl" v-else>
            <table>
              <thead>
                <tr>
                  <th style="width:160px;">年度</th>
                  <th style="width:160px;">電気使用量</th>
                  <th style="width:160px;" v-show="showAirConditionerControl">制御時限回数</th>
                  <th style="width:160px;" v-show="showAirConditionerControl">抑制電力量</th>
                </tr>               
              </thead>
              <tbody>
                <tr>
                  <td>{{ this.selectedDate }}</td>
                  <td style="text-align:right; padding-right:25px;"><span>{{ controlDataList.length == 3 ? controlDataList[0].electricPower : "0" }}</span>MWh</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[0].controlTimeCount : "0" }}</span>回</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[0].controlPower : "0" }}</span>MWh</td>
                </tr>
                <tr>
                  <td>{{ this.selectedDate-1 }}</td>
                  <td style="text-align:right; padding-right:25px;"><span>{{ controlDataList.length == 3 ? controlDataList[1].electricPower : "0" }}</span>MWh</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[1].controlTimeCount : "0" }}</span>回</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[1].controlPower : "0" }}</span>MWh</td>
                </tr>
                <tr>
                  <td>{{ this.selectedDate-2 }}</td>
                  <td style="text-align:right; padding-right:25px;"><span>{{ controlDataList.length == 3 ? controlDataList[2].electricPower : "0" }}</span>MWh</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[2].controlTimeCount : "0" }}</span>回</td>
                  <td style="text-align:right; padding-right:25px;" v-show="showAirConditionerControl"><span>{{ controlDataList.length == 3 ? controlDataList[2].controlPower : "0" }}</span>MWh</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="chart_wrap">
            <div id="monitoring_legend" class="legend"></div>
            <div class="container">
              <p class="label_left" v-if="graphType == 1">(kW)</p>
              <p class="label_left" v-else>(MWh)</p>
              <p class="label_bottom" v-if="graphType == 1">(時)</p>
              <p class="label_right2" v-if="graphType == 1">(℃)</p>
              <div style="width:1045px;height:417px;">
                <canvas id="monitoring_canvas2"></canvas>
              </div>
              <ul class="weather" v-if="isDispDayGraph">
                <li v-for="(item,index) in weathers" v-bind:key="index">
                  <dl>
                    <dt>
                      <img v-bind:src="getWeatherIconUrl(item.weather)">
                    </dt>
                    <dd
                      v-bind:class="getTempStyle(item.temperature)"
                      v-if="item.temperature != undefined"
                    >
                      <span>{{ item.temperature}}</span>℃
                    </dd>
                    <dd v-else v-bind:class="getTempStyle(item.temperature)">
                      <span>&nbsp;</span>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <meter-dialog
      @close="showModalMeter=false"
      v-if="showModalMeter"
      :account="this.$store.state.childID"
      :name="this.$store.state.childInfo.power_info.company_name"
    ></meter-dialog>
    <download-dialog
      @close="showModal=false"
      v-if="showModal"
      :type="downloadType"
      :account="this.$store.state.childID"
    ></download-dialog>
  </div>
</template>

<script>
/* eslint-disable */
// import Chart from "chart.js";
// import $ from "jquery";
import moment from "moment";
import DownloadDialog from "../components/DownloadDialog";
import MeterDialog from "../components/MeterDialog";
import Store from "../store";

export default {
  name: "monitoring",
  components: {
    DownloadDialog,
    MeterDialog
  },
  watch: {
    selectedDate: function(newValue, oldValue) {
      this.updateData(newValue);
    },
    graphType: function(newValue, oldValue) {
      if (newValue == 1) {
        // 日間デマンド
        $("#chart_monitoring_text").html("表示日");
        this.dateOptions = this.getMonitoringDateOptions();
        this.selectedDate = moment().format("YYYY/MM/DD");
        this.isDispDayGraph = 1;
      } else if (newValue == 2) {
        // 月間電力使用実績
        $("#chart_monitoring_text").html("表示月");
        this.dateOptions = this.getMonitoringMonthOptions();
        this.selectedDate = moment().format("YYYY/MM");
        this.isDispDayGraph = 0;
      } else {
        // 年間電力使用実績、検針データ
        $("#chart_monitoring_text").html("表示年");
        const oldDate = this.selectedDate;
        this.dateOptions = this.getMonitoringYearOptions();
        this.selectedDate = moment().format("YYYY");
        this.isDispDayGraph = 0;
        if (this.selectedDate == oldDate) {
          this.updateData(this.selectedDate);
        }
      }
    }
  },
  data: function() {
    return {
      dateOptions: [],
      selectedDate: "",
      weathers: [],
      chart: null,
      showModal: false,
      showModalMeter: false,
      downloadType: "weatherfile",
      graphType: 1,
      isDispDayGraph: 1,
      airConditionerControlFlg: false,
      dayFlg: true,
      electricPower: "",
      controlTimeCount: "",
      maxControlDemand: "",
      controlPower: "",
      controlDataList:[],
      showYearControl:false,
      showAirConditionerControl:false
    };
  },

  mounted: function() {
    //
    console.log("---------- mounted");

    this.dateOptions = this.getMonitoringDateOptions();

    const monitoringDate = Store.state.monitoringDate;
    if (monitoringDate == "") {
      this.selectedDate = moment().format("YYYY/MM/DD");
    } else {
      this.selectedDate = monitoringDate;
      Store.dispatch("resetMonitoringDate");
    }
  },
  methods: {
    // downloadFile: function() {
    //   const startDate = moment.utc(this.selectedDate, "YYYY/MM/DD").add(1, "days");
    //   const startDateStr = this.selectedDate + " 00:00:00";
    //   const endDateStr = startDate.format("YYYY/MM/DD") + " 00:00:00";
    //   const param = {
    //     start_datetime: startDateStr,
    //     end_datetime: endDateStr
    //   };
    //   console.log(`downloadFile=`);
    //   console.log(param);

    //   const fileName =
    //     moment(this.selectedDate, "YYYY/MM/DD").format("YYYYMMDD") + ".pdf";
    //   this.$axios
    //     .post(`/srv/api/demandfile/${this.$store.state.childID}`, param, {
    //       withCredentials: true,
    //       responseType: "blob"
    //     })
    //     .then(response => {
    //       console.log(response);

    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", fileName);
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(error => {
    //       // ...
    //       console.log(error);
    //     });
    // },
    updateData: function(date) {
      if (this.chart != null) {
        this.chart.destroy();
      }
      this.showAirConditionerControl = false;
      this.showYearControl=true;
      if (this.graphType == 1) {
        // 日間デマンド
        this.updateDataDay(date);
      } else if (this.graphType == 2) {
        // 月間電力使用実績
        this.updateDataMonth(date + "/01");
      } else if (this.graphType == 3) {
        // 年間電力使用実績
        this.updateDataYear(date + "/04/01");
      } else if (this.graphType == 4) {
        this.showYearControl=false;
        // 検針データ
        this.updateDataMeter(date + "/04/01");
      }
    },
    updateDataDay: function(date) {
      this.$axios
        .post(
          `/srv/api/daytoday/${this.$store.state.childID}`,
          { date: date },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            if (response.data.status == "failure") {
              console.warn("daytoday failure");
            } else {
              this.drawMonitoringChart(response.data);
            }
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateDataMonth: function(date) {
      this.$axios
        .post(
          `/srv/api/monthly_power/${this.$store.state.childID}`,
          { date: date },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            if (response.data.status == "failure") {
              console.warn("daytoday failure");
            } else {
              this.drawMonitoringChartMonth(response.data);
            }
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateDataYear: function(date) {
      this.$axios
        .post(
          `/srv/api/yearly_power/${this.$store.state.childID}`,
          { date: date },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            if (response.data.status == "failure") {
              console.warn("daytoday failure");
            } else {
              console.log(response.data);
              this.drawMonitoringChartYear(response.data);
            }
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateDataMeter: function(date) {
      this.$axios
        .post(
          `/srv/api/yearly_meter/${this.$store.state.childID}`,
          { date: date },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            if (response.data.status == "failure") {
              console.warn("daytoday failure");
            } else {
              this.drawMonitoringChartYear(response.data);
            }
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    drawMonitoringChart: function(data) {
      const demand = data.demand;

      const timeTable48ForDemand = this.createMonitoringTimeTable48ForDemand(this.selectedDate);
      const timeTable48 = this.createMonitoringTimeTable48(this.selectedDate);
      const timeTable24 = this.createMonitoringTimeTable24(this.selectedDate);
      const timeTable12 = this.createMonitoringTimeTable12(this.selectedDate);
      const self = this;

      const timeArray = Array.prototype.concat.apply(
        [],
        [...Array(25).keys()].map(v => {
          return [
            String(v).padStart(1, '0') + "時",
            String(v).padStart(1, '0') + "時30分"
          ];
        })
      );
      
      // サマリー
      this.airConditionerControlFlg = data.air_conditioner_control_flg;
      this.electricPower = data.electric_power != null ? Math.round( data.electric_power * Math.pow( 10, 1 ) ) / Math.pow( 10, 1 ) : "0";
      this.controlTimeCount = data.electric_power != null ? data.control_time_count : "0";
      this.maxControlDemand = data.max_control_demand != null ? Math.round( data.max_control_demand * Math.pow( 10, 1 ) ) / Math.pow( 10, 1 ) : "0";
      this.controlPower = data.control_power != null ? Math.round( data.control_power * Math.pow( 10, 1 ) ) / Math.pow( 10, 1 ) : "0";

      // 空調機制御有り and 空調機の登録
      if (data.air_conditioner_control_flg && data.air_conditioner_signin_flg){
        this.showAirConditionerControl = true;
      }
      // 最大抑制デマンド 表示
      this.dayFlg = true;

      let monitoring_demand = Array(48);
      data.demand.forEach(element => {
        const index = timeTable48ForDemand.indexOf(element.datetime);
        monitoring_demand[index] = Math.round( element.demand * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
      });

      let monitoring_temperature_actual = Array(48);
      for (let index = 0; index < data.temperature_actual.length; index++) {
        const element = data.temperature_actual[index];
        const pos = timeTable48.indexOf(element.datetime);
        monitoring_temperature_actual[pos] = element.temperature;
      }

      let monitoring_temperature_forecast = Array(48);
      for (let index = 0; index < data.temperature_forecast.length; index++) {
        const element = data.temperature_forecast[index];
        const pos = timeTable48.indexOf(element.datetime);
        monitoring_temperature_forecast[pos] = element.temperature;
      }

      let monitoring_control_demand = Array(48);
      data.control_demand.forEach(element => {
        const index = timeTable48.indexOf(element.datetime);
        monitoring_control_demand[index] = Math.round( element.demand * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
      });

      this.weathers = Array(12).fill({
        weather: undefined,
        temperature: undefined
      });
      data.weather.forEach(element => {
        const index = timeTable12.indexOf(element.datetime);
        this.weathers[index] = {
          weather: element.weather,
          temperature: element.temperature
        };
      });

      var monitoring_kw_min = data.demand_min; //kWの最小値
      var monitoring_kw_max = data.demand_max; //kWの最大値
      var monitoring_kw_step = 10; //kWの表示間隔
      var monitoring_degree_min = data.temperature_min; //℃の最小値
      var monitoring_degree_max = data.temperature_max; //℃の最大値
      var monitoring_degree_step = 10; //℃の表示間隔

      if (monitoring_kw_max > 100) {
        monitoring_kw_step = Math.floor(monitoring_kw_max / 100) * 10;
      }

      var a = document.getElementById("monitoring_canvas2").getContext("2d");
      var b = a.createLinearGradient(0, 0, 0, 380);
      b.addColorStop(0, "rgba(113, 147, 255, 1)");
      b.addColorStop(1, "rgba(193, 208, 255, 1)");
      var e = {
        labels: [
          "",
          "1",
          "",
          "2",
          "",
          "3",
          "",
          "4",
          "",
          "5",
          "",
          "6",
          "",
          "7",
          "",
          "8",
          "",
          "9",
          "",
          "10",
          "",
          "11",
          "",
          "12",
          "",
          "13",
          "",
          "14",
          "",
          "15",
          "",
          "16",
          "",
          "17",
          "",
          "18",
          "",
          "19",
          "",
          "20",
          "",
          "21",
          "",
          "22",
          "",
          "23",
          "",
          "24"
        ],
        datasets: [
          {
            type: "line",
            label: "実測気温",
            data: monitoring_temperature_forecast,
            borderColor: "#FAC090",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "予報気温",
            data: monitoring_temperature_actual,
            borderColor: "rgba(27,200,152,1.0)",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "デマンド実績",
            data: monitoring_demand,
            backgroundColor: b,
            hoverBackgroundColor: b,
            yAxisID: "y-axis-2",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "デマンド抑制",
            data: monitoring_control_demand,
            backgroundColor: "rgba(255, 0, 0, 1)",
            hoverBackgroundColor: "rgba(255, 0, 0, 1)",
            yAxisID: "y-axis-2",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var c = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(g) {
          var h = [];
          h.push("<span>グラフ表示選択</span>");
          h.push('<ul class="' + g.id + '-legend">');
          for (var f = 0; f < g.data.datasets.length; f++) {
            switch (f) {
              case 0: // 実測気温
                h.push("<li id='day-legend'><span>");
                h.push(g.data.datasets[f+2].label);
                break;
              case 1: // 予報気温
              case 2: // デマンド実績
                h.push("<li id='day-legend'><span>");
                h.push(g.data.datasets[f-1].label);
                break;
              case 3: // デマンド抑制
                if (data.air_conditioner_control_flg) {
                  h.push("<li id='day-legend'><span>");
                  h.push(g.data.datasets[f].label);
                }
                break;
            }
          } 

          h.push("</ul>");
          return h.join("");
        },
        elements: {
          line: {
            tension: 0
          },
          point: {
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              },
              stacked: true,
            }
          ],
          yAxes: [
            {
              id: "y-axis-2",
              type: "linear",
              position: "left",
              stacked: true,
              ticks: {
                max: monitoring_kw_max,
                min: monitoring_kw_min,
                stepSize: monitoring_kw_step
              }
            },
            {
              id: "y-axis-1",
              type: "linear",
              position: "right",
              ticks: {
                max: monitoring_degree_max,
                min: monitoring_degree_min,
                stepSize: monitoring_degree_step
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        tooltips: {
          mode: 'label',
          filter: function (tooltipItem) {
            if (tooltipItem.value > 0) {
              return true;
            }
          },
          callbacks: {
            title: (tooltipItem, data) => {
              return timeArray[tooltipItem[0].index+1];
            },
            label: (tooltipItem, data) => {
              if (tooltipItem.datasetIndex == 2) {
                return "デマンド実績: " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              } else if (tooltipItem.datasetIndex == 3) {
                return "デマンド抑制: " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              }
            }
          }
        }
      };
      //
      if (this.chart != null) {
        this.chart.destroy();
      }

      this.chart = new Chart(
        document.getElementById("monitoring_canvas2").getContext("2d"),
        {
          type: "bar",
          data: e,
          options: c
        }
      );

      $("#monitoring_legend").html(this.chart.generateLegend());
      $("#monitoring_legend").off("click", "li");
      $("#monitoring_legend").on("click", "li", function() {
        $(this).toggleClass("hide");
        var f = $(this).index();
        if (f == 0) {
          f = 2;
        } else if (f == 2) {
          f = 0;
        }
        var g = self.chart.getDatasetMeta(f);
        g.hidden =
          g.hidden === null ? !self.chart.data.datasets[f].hidden : null;
        self.chart.update();
      });
    },
    drawMonitoringChartMonth: function(data) {
      // 最大抑制デマンド 非表示
      this.dayFlg = false;

      // サマリー
      this.airConditionerControlFlg = data.air_conditioner_control_flg;
      this.electricPower = data.electric_power != null ? Math.round( data.electric_power * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ) : "0";
      this.controlTimeCount = data.electric_power != null ? data.control_time_count : "0";
      this.controlPower = data.control_power != null ? Math.round( data.control_power * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ) : "0";
      // 空調機制御有り and 空調機の登録
      if (data.air_conditioner_control_flg && data.air_conditioner_signin_flg){
        this.showAirConditionerControl = true;
      }
      // if (data.demand.length == 0) {
      //   console.log("no graph data");
      //   if (this.chart) {
      //     this.chart.destroy();
      //   }
      //   return;
      // }

      var a = document.getElementById("monitoring_canvas2").getContext("2d");
      var b = a.createLinearGradient(0, 0, 0, 380);
      b.addColorStop(0, "rgba(113, 147, 255, 1)");
      b.addColorStop(1, "rgba(193, 208, 255, 1)");

      let labelData = [];
      for (let i = 0; i < data.demand.length; i++) {
        labelData.push(data.demand[i].date);
      }

      let graphDataList = [];
      let powerList = [];
      for (let i = 0; i < data.demand.length; i++) {
        if (data.demand[i].value != null) {
          let val = data.demand[i].value / 1000;
          val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
          powerList.push(val);
        }
      }

      let controlPowerList = [];
      for (let i = 0; i < data.control_demand.length; i++) {
        if (data.control_demand[i].value != null) {
          let val = data.control_demand[i].value / 1000;
          val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
          controlPowerList.push(val);
        }
      }

      let powerData = {
        label: "電力使用量",
        data: powerList,
        backgroundColor: b,
        hoverBackgroundColor: b,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(powerData);
      let controlPowerData = {
        label: "抑制電力量",
        data: controlPowerList,
        backgroundColor: "rgba(255, 0, 0, 1)",
        hoverBackgroundColor: "rgba(255, 0, 0, 1)",
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(controlPowerData);

      var chartData = {
        labels: labelData,
        datasets: graphDataList
      };

      var options = {
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(g) {
          var h = [];
          h.push("<span>グラフ表示選択</span>");
          h.push('<ul class="' + g.id + '-legend">');
          for (var f = 0; f < g.data.datasets.length; f++) {
            if (g.data.datasets[f].label && g.data.datasets[f].label != "デマンド抑制") {
              if (g.data.datasets[f].label == "抑制電力量") {
                if (data.air_conditioner_control_flg) {
                  h.push("<li id='month-legend'><span>");
                  h.push(g.data.datasets[f].label);
                }
              } else {
                h.push("<li id='month-legend'><span>");
                h.push(g.data.datasets[f].label);
              }
            }
            h.push("</span></li>");
            }
          h.push("</ul>");
          return h.join("");
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              min: 0,
              callback: function(label, index, labels) {
                return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            },
            stacked: true,
          }]
        },
        tooltips: {
          mode: 'label',
          filter: function (tooltipItem) {
            if (tooltipItem.value > 0) {
              return true;
            }
          }
        }
      };
      
      if (this.chart) {
        this.chart.destroy();
      }
      
      this.chart = new Chart(
        document.getElementById("monitoring_canvas2").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: options
        }
      );
      self = this;
      $("#monitoring_legend").html(this.chart.generateLegend());
      $("#monitoring_legend").off("click", "li");
      $("#monitoring_legend").on("click", "li", function() {
        $(this).toggleClass("hide");
        var f = $(this).index();
        var g = self.chart.getDatasetMeta(f);
        g.hidden =
          g.hidden === null ? !self.chart.data.datasets[f].hidden : null;
        self.chart.update();
      });
    },
    drawMonitoringChartYear: function(data) {

      // 最大抑制デマンド 非表示
      this.dayFlg = false;

      // サマリー
      this.airConditionerControlFlg = data.air_conditioner_control_flg;
      
      this.controlDataList = [];
      if (this.graphType == 3){
        for (let i = 0; i < data.electric_power.length; i++) {
          var newList = {
            year:this.selectedDate-i,
            electricPower:(data.electric_power[i] != null) ? Math.round( data.electric_power[i] * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ) : "0",
            controlTimeCount:(data.electric_power[i] != null) ? data.control_time_count[i] : "0",
            controlPower:(data.control_power[i] != null) ? Math.round( data.control_power[i] * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ) : "0",
          }
          this.controlDataList.push(newList)
        }

        // 空調機制御有り and 空調機の登録
        if (data.air_conditioner_control_flg && data.air_conditioner_signin_flg){
          this.showAirConditionerControl = true;
        }
      }
      
      // if (data.demand.length == 0) {
      //   console.log("no graph data");
      //   if (this.chart) {
      //     this.chart.destroy();
      //   }
      //   return;
      // }
      
      var a = document.getElementById("monitoring_canvas2").getContext("2d");
      var b = a.createLinearGradient(0, 0, 0, 380);
      b.addColorStop(0, "rgba(113, 147, 255, 1)");
      b.addColorStop(1, "rgba(193, 208, 255, 1)");
      var c = a.createLinearGradient(0, 0, 0, 380);
      c.addColorStop(0, "rgba(167, 167, 167, 1)");//a7a7a7
      c.addColorStop(1, "rgba(230, 230, 230, 1)");//e6e6e6
      var d = a.createLinearGradient(0, 0, 0, 380);
      d.addColorStop(0, "rgba(199, 199, 199, 1)");//#c7c7c7
      d.addColorStop(1, "rgba(240, 240, 240, 1)");//#f0f0f0

      let labelData = [];
      for (let i = 0; i < data.demand.length; i++) {
        labelData.push(data.demand[i].month);
      }

      let graphDataList = [];
      let powerOneList = [], yearArray1Data = [];
      for (let i = 0; i < data.demand.length; i++) {
        yearArray1Data.push(data.demand[i].month);
        if (data.demand[i].value != null) {
          let val = data.demand[i].value / 1000;
          val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
          powerOneList.push(val);
        }
      }
      let powerTwoList = [], yearArray2Data = [];
      for (let i = 0; i < data.demandLastYear.length; i++) {
        yearArray2Data.push(data.demandLastYear[i].month);
        if (data.demandLastYear[i].value != null) {
          let val = data.demandLastYear[i].value / 1000;
          val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
          powerTwoList.push(val);
        }
      }
      let powerThreeList = [], yearArray3Data = [];
      for (let i = 0; i < data.demandBeforeLast.length; i++) {
        yearArray3Data.push(data.demandBeforeLast[i].month);
        if (data.demandBeforeLast[i].value != null) {
          let val = data.demandBeforeLast[i].value / 1000;
          val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
          powerThreeList.push(val);
        }
      }

      let controlPowerOneList = [];
      if (data.control_demand != undefined) {
        for (let i = 0; i < data.control_demand.length; i++) {
          if (data.control_demand[i].value != null) {
            let val = data.control_demand[i].value / 1000;
            val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
            controlPowerOneList.push(val);
          }
        }
      }
      let controlPowerTwoList = [];
      if (data.control_demandLastYear != undefined) {
        for (let i = 0; i < data.control_demandLastYear.length; i++) {
          if (data.control_demandLastYear[i].value != null) {
            let val = data.control_demandLastYear[i].value / 1000;
            val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
            controlPowerTwoList.push(val);
          }
        }
      }
      let controlPowerThreeList = [];
      if (data.control_demandBeforeLast != undefined) {
        for (let i = 0; i < data.control_demandBeforeLast.length; i++) {
          if (data.control_demandBeforeLast[i].value != null) {
            let val = data.control_demandBeforeLast[i].value / 1000;
            val = Math.round( val * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 );
            controlPowerThreeList.push(val);
          }
        }
      }      
      let thisYearPowerData = {
        label: "電力使用量",
        stack: "one",
        data: powerOneList,
        backgroundColor: b,
        hoverBackgroundColor: b,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(thisYearPowerData);
      let thisYearControlPowerData = {
        label: "抑制電力量",
        stack: "one",
        data: controlPowerOneList,
        backgroundColor: "rgba(255, 0, 0, 1)",
        hoverBackgroundColor: "rgba(255, 0, 0, 1)",
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(thisYearControlPowerData);
      let thisYearNullData = {
        label: "",
        stack: "one",
        data: []
      };
      graphDataList.push(thisYearNullData);
      let lastYearPowerData = {
        label: "去年電力使用量",
        stack: "two",
        data: powerTwoList,
        backgroundColor: c,
        hoverBackgroundColor: c,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(lastYearPowerData);
      let lastYearControlPowerData = {
        label: "去年抑制電力量",
        stack: "two",
        data: controlPowerTwoList,
        backgroundColor: "rgba(255, 100, 100, 1)",
        hoverBackgroundColor: "rgba(255, 100, 100, 1)",
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(lastYearControlPowerData);
      let lastYearNullData = {
        label: "",
        stack: "two",
        data: []
      };
      graphDataList.push(lastYearNullData);
      let beforeLastYearPowerData = {
        label: "一昨年電力使用量",
        stack: "three",
        data: powerThreeList,
        backgroundColor: d,
        hoverBackgroundColor: d,
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(beforeLastYearPowerData);
      let beforeLastYearControlPowerData = {
        label: "一昨年抑制電力量",
        stack: "three",
        data: controlPowerThreeList,
        backgroundColor: "rgba(255, 170, 170, 1)",
        hoverBackgroundColor: "rgba(255, 170, 170, 1)",
        pointRadius: 0,
        pointHoverRadius: 0,
        pointHitRadius: 0
      };
      graphDataList.push(beforeLastYearControlPowerData);
      let beforeLastYearNullData = {
        label: "",
        stack: "three",
        data: []
      };
      graphDataList.push(beforeLastYearNullData);

      var chartData = {
        labels: labelData,
        datasets: graphDataList
      };

      var options = {
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(g) {
          var h = [], h1 = "", h2 = "";
          h1 += '<div><span>グラフ表示選択</span><ul class="' + g.id + '-legend">';
          h2 += '<div style="margin-top: 10px;"><ul class="' + g.id + '-legend">';
          for (var f = 0; f < g.data.datasets.length; f++) {
            if (g.data.datasets[f].label && g.data.datasets[f].label != "デマンド抑制") {
              if (g.data.datasets[f].label.includes("抑制電力量")) {
                if (data.air_conditioner_control_flg) {
                  h2 += "<li id='year-2-legend'><span>";
                  h2 += g.data.datasets[f].label;
                  h2 += "</span></li>";
                }
              } else {
                h1 += "<li id='year-1-legend'><span>";
                h1 += g.data.datasets[f].label;
                h1 += "</span></li>";
              }
            }
          }
          h1 += "</ul></div>";
          h2 += "</ul></div>";
          h.push(h1);
          h.push(h2);
          return h.join("");
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              min: 0,
              callback: function(label, index, labels) {
                return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            },
            stacked: true
          }]
        },
        tooltips: {
          mode: 'x',
          filter: function (tooltipItem) {
            if (tooltipItem.value > 0) {
              return true;
            }
          },
          callbacks: {
            title: (tooltipItem, data) => {
              if (tooltipItem[0].datasetIndex == 0 || tooltipItem[0].datasetIndex == 1) {
                return yearArray1Data[tooltipItem[0].index];
              } else if (tooltipItem[0].datasetIndex == 3 || tooltipItem[0].datasetIndex == 4) {
                return yearArray2Data[tooltipItem[0].index];
              } else if (tooltipItem[0].datasetIndex == 6 || tooltipItem[0].datasetIndex == 7) {
                return yearArray3Data[tooltipItem[0].index];
              }
            }
          }
        }
      };

      if (this.chart) {
        this.chart.destroy();
      }
      
      this.chart = new Chart(
        document.getElementById("monitoring_canvas2").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: options
        }
      );
      self = this;
      $("#monitoring_legend").html(this.chart.generateLegend());
      $("#monitoring_legend").off("click", "li");
      $("#monitoring_legend").on("click", "li", function() {
        $(this).toggleClass("hide");
        var f = $(this).index();
        if (this.id.includes("1")) {
          f = 3 * f;
        } else if (this.id.includes("2")) {
          f = 3 * f + 1;
        }
        var g = self.chart.getDatasetMeta(f);
        g.hidden =
          g.hidden === null ? !self.chart.data.datasets[f].hidden : null;
        self.chart.update();
      });
    }
  }
};
</script>

